export const LOAN_RELATED_CONTACT_MODEL_KEYS = {
  company: "company",
  createdBy: "createdBy",
  emailAddress: "emailAddress",
  firstName: "firstName",
  lastName: "lastName",
  loanId: "loanId",
  loanRole: "loanRole",
  phone: "phone",
  updateDateTime: "updateDateTime",
  updatedBy: "updatedBy",
};
